import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ArrendondaCasasDecimaisPipe } from 'app/pipes/arrendondaCasasDecimais/arrendonda-casas-decimais.pipe';

@Component({
  selector: 'app-media-grafico',
  standalone: true,
  imports: [
    ArrendondaCasasDecimaisPipe,
    MatTooltipModule,
  ],
  templateUrl: './media-grafico.component.html',
  styleUrl: './media-grafico.component.css'
})

export class MediaGraficoComponent implements OnInit, OnDestroy {
  @Input() corFundo: string = '';
  @Input() corIcone: string = '';
  @Input() srcIcone: string = '';
  @Input() titulo: string = '';
  @Input() meta: number = 0;
  @Input() real: number = 0;

  get rotacaoPonteiro(): number {
    const rotacao = (this.real / this.meta) * 180 - 90;
    return rotacao > 90 ? 90 : rotacao;
  }

  private resizeListener: any;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.resizeListener = () => {
      this.cdr.detectChanges();
    };
    window.addEventListener('resize', this.resizeListener);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.resizeListener);
  }

  get polygonTransform(): string {
    const base = `rotate(${this.rotacaoPonteiro} 100 95)`;
    return window.innerWidth <= 1536 ? `${base} translate(0,0)` : base;
  }
}
